import React from 'react'
import PropTypes from 'prop-types'
import ErrorDisplay from '../ErrorDisplay'
import './AddDomainForm.css'
import 'font-awesome/css/font-awesome.css'

const AddDomainForm = (props) => {

	const submit = (evt) => {
		evt.preventDefault()
		props.submit(props.domain)
	}

	const domainChanged = (evt) => {
		props.domainChanged(evt.target.value)
	}

	return (
		<form className="form" onSubmit={submit}>
			<p className="field">
				<input className="domain" type="text" onChange={domainChanged} value={props.domain} placeholder="domain" name="domain" id="domain" disabled={props.disabled}/>
				<i className="fa fa-server fa-lg"/>
			</p>
			<p className="submit">
				<button className="submitDomain" type="submit" disabled={props.disabled}>
					<i className="fa fa-arrow-right fa-lg"/>
				</button>
			</p>
			<ErrorDisplay err={props.err}/>
		</form>
	)
}

AddDomainForm.propTypes = {
	domain: PropTypes.string.isRequired,
	submit: PropTypes.func.isRequired,
	domainChanged: PropTypes.func.isRequired,
	disabled: PropTypes.bool.isRequired
}

export default AddDomainForm





// WEBPACK FOOTER //
// ./src/components/AddDomainForm/AddDomainForm.js